import { html, css } from "../utils/template-literal-tags";

class EntryEditModal extends HTMLElement {
  entry = null;

  constructor() {
    super();
    this.attachShadow({ mode: "open" });

    const styles = css`
      div#buffer {
        padding: 0 20px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      div#container {
        border: 1px solid var(--darkblue3);
        background: var(--dark8);
        border-radius: 4px;
        padding: 20px;
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        font-size: 14px;

        div.tag-name {
          font-size: 16px;
        }

        input[type="time"],
        textarea {
          appearance: none;
          background: transparent;
          color: white;
          border: none;
        }
      }
    `;

    this.shadowRoot.innerHTML = html`
      <style>
        ${styles}
      </style>
      <div id="content"></div>
    `;

    this.content = this.shadowRoot.getElementById("content");
  }

  connectedCallback() {
    this.render();
  }

  /**
    1. tag title
    2. rhythm data
    3. start/stop times
    4. duration
    5. comment (inside editable input area)
    6. update button if you edit any of the data
        - sends it with additional 'updated' key, which has the new data, so the old data can be used to identify and update the data in the log
  */
  render() {
    this.content.innerHTML = html`
      <div id="buffer">
        <div id="container">
          <div class='tag-name'>#${this.entry.tags}</div>
          <div class='duration'>${this.entry.duration} mins</div>
          <div class='times'>
            <input type='time' id='startTime' value='${this.entry.start}'></input>
            <input type='time' id='endTime' value='${this.entry.end}'></input>
          </div>
          <textarea id='comment'>${this.entry.comment}</textarea>
        </div>
      </div>
    `;
  }

  disconnectedCallback() {
    this.postUpdate();
  }

  async postUpdate() {
    const originalEntry = { ...this.entry };
    const newEntry = { ...this.update() };

    console.log("postUpdate", originalEntry, newEntry);

    const event = new CustomEvent("submit-data", {
      bubbles: true,
      composed: true,
      detail: {
        endpoint: "/entries/replace-entry",
        method: "POST",
        payload: {
          originalEntry: originalEntry,
          newEntry: newEntry,
        },
      },
    });

    this.dispatchEvent(event);
  }

  update() {
    this.entry.start = this.shadowRoot.getElementById("startTime").value;
    this.entry.end = this.shadowRoot.getElementById("endTime").value;
    this.entry.comment = this.shadowRoot.getElementById("comment").value;
    return this.entry;
  }

  set setEntry(entry) {
    this.entry = entry;
  }
}

customElements.define("entry-edit-modal", EntryEditModal);
